import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

import createScheduler from '@/polyfills/create-scheduler';

const useNoGridAnimationsOnNavigation = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // re-add animations after load
    (async () => {
      const taskScheduler = createScheduler();
      await taskScheduler
        .schedule(
          () => {
            const root = document.documentElement;
            root.style.setProperty('--layout-grid-animation-duration', '300ms');
          },
          {
            delay: 0,
            priority: 'background',
          }
        )
        .catch(console.error);
    })();

    return () => {
      // remove animations on cleanup because we are assuming we are navigating routes
      const root = document.documentElement;
      root.style.setProperty('--layout-grid-animation-duration', '0s');
    };
  }, [pathname]);
};

export default useNoGridAnimationsOnNavigation;
